import { Button, Center, Wrap, WrapItem, type WrapProps } from '@chakra-ui/react'

import ShwLink from '@/components/ShwLink'

import PartnerLogo from './PartnerLogo'
import type { PartnerLogoItem } from './types'

export default function PartnerLogosWrap({
  partners,
  disableSpread = false,
  greyscale = false,
  scaleMultiplier = 1,
  linkToPartnershipsPage = false,
  spacing = '28px',
  plusMoreHref,
  ...wrapProps
}: WrapProps & {
  partners: PartnerLogoItem[]
  greyscale?: boolean
  scaleMultiplier?: number
  linkToPartnershipsPage?: boolean
  disableSpread?: boolean
  spacing?: WrapProps['spacing']
  plusMoreHref?: string
}): JSX.Element {
  return (
    <Wrap align="center" justify="center" width="100%" {...wrapProps} spacing={spacing}>
      {partners.map(partner => (
        <WrapItem key={partner.logoSrc} justifyContent="center" flex={disableSpread ? 0 : 1}>
          <PartnerLogo
            partner={partner}
            greyscale={greyscale}
            scaleMultiplier={scaleMultiplier}
            linkToPartnershipsPage={linkToPartnershipsPage}
          />
        </WrapItem>
      ))}

      {plusMoreHref != null ? (
        <WrapItem flex={disableSpread ? 0 : 1}>
          <Center width="100%">
            <ShwLink href={plusMoreHref}>
              <Button variant="ghost">+ more</Button>
            </ShwLink>
          </Center>
        </WrapItem>
      ) : null}
    </Wrap>
  )
}
